import React, { CSSProperties, ReactNode, FC } from 'react';

interface ModalContentProps {
  style?: CSSProperties;
  children: ReactNode;
}

/** A scrollable container for modal contents, to be used within a `<Modal />` component */
const ModalContent: FC<ModalContentProps> = ({
  style,
  children,
}: ModalContentProps) => {
  return (
    <div
      style={{
        fontFamily: 'Roboto, sans-serif',
        fontSize: '16px',
        fontWeight: 300,
        lineHeight: '20px',
        overflow: 'hidden',
        ...style,
      }}
    >
      <div className="h100 p5 modal-content-wrapper">{children}</div>
    </div>
  );
};

export default ModalContent;
